// Authentication API Calls

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

export const authApi = {
  // Login API Call
  login: async (username, password) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.LOGIN, {
        username,
        password,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Logout API Call
  logout: async () => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.LOGOUT);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get Current User
  getCurrentUser: async () => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.AUTH.ME);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Refresh Token
  refreshToken: async () => {
    try {
      const refresh_token = localStorage.getItem('refresh_token');
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.REFRESH_TOKEN, {
        refresh_token,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Forgot Password — send OTP to email
  forgotPassword: async (email) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Reset Password — submit email + otp + new_password
  resetPassword: async (email, otp, new_password) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, {
        email,
        otp,
        new_password,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Change Password (authenticated)
  changePassword: async (current_password, new_password) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, {
        current_password,
        new_password,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default authApi;
